import clsx from 'clsx';
import { getValueForSelection, mapLabel } from 'components/CruiseSearchWidget/utils/reducers';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { PillButton } from 'components/buttons/PillButton/PillButton';
import { useAppContext } from 'contexts/appContext';
import { ListFilterOption } from 'lib/apiClient';
import { useCallback } from 'react';
import styles from './FilterOptions.css';

interface FilterOptionsProps {
	label: string;
	options: ListFilterOption[];
	group?: string;
	filterKey?: string;
	isUniqueFilter?: boolean;
}

export function FilterOptions({ label, options, group, filterKey, isUniqueFilter }: Readonly<FilterOptionsProps>) {
	const { activeFilter, updateSelection, historicalSelection } = useFiltersContext();
	const { dictionary } = useAppContext();

	const handleOptionClick = useCallback(
		(filter: string | undefined, option: ListFilterOption) => {
			if (!filter) return;
			const value = getValueForSelection(option, historicalSelection);
			updateSelection(filter, { value, group, containers: option.containers, criteria: option.criteria });
		},
		[updateSelection, group, historicalSelection],
	);

	return (
		<div className={clsx(styles.root, { [styles.uniqueFilter]: isUniqueFilter })}>
			{label && <span className={styles.subTitle}>{label}</span>}
			{options && (
				<div className={styles.options}>
					{options?.map((option) => (
						<PillButton
							key={option.code}
							testId={`${activeFilter?.key}-pill-button-${option.code}`}
							label={mapLabel(option.label, activeFilter?.key, dictionary)}
							onClick={() => handleOptionClick(filterKey ?? activeFilter?.key, option)}
							isSelected={option.isSelected}
							isDisabled={option.isDisabled}
						/>
					))}
				</div>
			)}
		</div>
	);
}
